export default class HelpButton {
    constructor(scene) {
        this.scene = scene;
        const button =  scene.add.image(800 - 95, 16, `help`, 0).setScale(1).setOrigin(1, 0).setScrollFactor(0).setInteractive();
        // button.width = 10;
        // button.height = 10;
        button.on('pointerdown', () => {
            // button.setTexture('buttoned_pressed');
            button.setAlpha(0.4);
            this.scene.events.emit('help-event');

            
            // scene.scene.launch('Pause', {scene: scene.scene.key, characterSelected});
            // scene.scene.pause();
        }).on('pointerup', () => {
            scene.scene.launch('Help', {scene: scene.scene.key});
            scene.scene.pause();
            scene.sound.mute = true;
            button.setAlpha(1)
        });
        
            
    }
}